import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

export interface SidebarPaymentIncidentBadgeProps {
  count: number;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarPaymentIncidentBadge({ count, variant }: SidebarPaymentIncidentBadgeProps) {
  const { t } = useTranslation('payment_incidents');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-payment-incidents-badge"
      label={t('badge_aria', { count })}
    />
  );
}
